import styled from 'styled-components';

export const GamePlanTableSection = styled.section`
  width: 100%;

  .ant-table,
  .ant-table-container,
  .ant-table-body {
    background: ${({ theme }) => theme.colors.transparent} !important;
  }

  .ant-table-container {
    border: none !important;
    border-radius: ${({ theme }) => theme.border_radius.none} !important;
  }

  .ant-table-header,
  .ant-table-header table,
  .ant-table-thead,
  .ant-table-thead > tr > th,
  .ant-table-thead > tr > th.ant-table-cell-scrollbar,
  .ant-table-cell-scrollbar {
    background: ${({ theme }) => theme.colors.transparent} !important;
  }

  .ant-table-thead > tr > th {
    color: ${({ theme }) => theme.colors.purple_1};
    padding-inline: var(--sorted-table-cell-padding-x) !important;
    border: none !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4} !important;
    box-shadow: none !important;
  }

  .ant-table-thead > tr > th span {
    color: ${({ theme }) => theme.colors.purple_1};
  }

  .ant-table-tbody > tr > td,
  .ant-table-tbody > tr > td.ant-table-cell,
  .ant-table-tbody-virtual .ant-table-row > .ant-table-cell,
  .ant-table-cell-scrollbar {
    background: ${({ theme }) => theme.colors.transparent} !important;
    border: none !important;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4} !important;
    box-shadow: none !important;
  }

  .ant-table-thead > tr > th:first-child,
  .ant-table-tbody > tr > td:first-child,
  .ant-table-tbody-virtual .ant-table-row > .ant-table-cell:first-child {
    padding-inline: ${({ theme }) => theme.spacing.lg}px !important;
  }
`;

export const GamePlanIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;

  > svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.grey_1};
  }
`;

export const GamePlanCell = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

export const GamePlanPrimaryText = styled.span`
  color: ${({ theme }) => theme.colors.grey_1};
  font-size: ${({ theme }) => theme.fonts.body3};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: ${({ theme }) => theme.fontsLineHeights.body3};
`;

export const GamePlanSecondaryText = styled.span`
  color: ${({ theme }) => theme.colors.grey_3};
  font-size: ${({ theme }) => theme.fonts.body4};
  line-height: ${({ theme }) => theme.fontsLineHeights.body4};
`;

export const GamePlanActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;

  .game-plan-view-button {
    color: ${({ theme }) => theme.colors.purple_1};
    background: ${({ theme }) => theme.colors.white_1};
    border-color: ${({ theme }) => theme.colors.purple_1};

    svg {
      color: ${({ theme }) => theme.colors.purple_1};
    }

    &:hover:not(:disabled),
    &:active:not(:disabled) {
      color: ${({ theme }) => theme.colors.white_1};
      background: ${({ theme }) => theme.colors.purple_1};
      border-color: ${({ theme }) => theme.colors.purple_1};

      svg {
        color: ${({ theme }) => theme.colors.white_1};
      }
    }
  }
`;
